export default {
	Skirt: 1,
	Trousers: 2,
	Sometimes: 3,
	Other: 4,
};
